function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { tokenManager } from '../token-manager';
import { createAuthAxiosInstance } from '../axios/auth-axios-instance';
import { isVSCodeEnvironment } from '../utils/vscode-env';
import { ID_TOKEN_KEY } from '../contexts/types';
import { createDefaultConfig } from '../types/auth-config';
import { createLogoutHandler, createFetchUserProfile, createFetchUserEmail, createStartFreshAuth } from '../contexts/auth-utils';
import { createGoogleTokenExchange, createGoogleAuthCodeExchange, createKakaoAuthCodeExchange } from '../contexts/oauth-handlers';
import { createAuthInitializer } from '../contexts/auth-initializer';
import { resolveStorageKeys } from '../storage-keys';
import { handleRefreshTokenFlow } from '../utils/refresh';
import { resolveAccessTokenRefreshDelay } from '../utils/refresh-scheduling';
export var useAuthProvider = function(param) {
    var config = param.config, ideMessagingService = param.ideMessagingService, navigationService = param.navigationService, injectedTokenManager = param.tokenManager;
    var _env, _contextValue_setAuthenticatedState, _contextValue_setAuthenticatedState1;
    // 설정 병합 (앱별 설정 + 기본값)
    var finalConfig = useMemo(function() {
        var defaultConfig = createDefaultConfig((config === null || config === void 0 ? void 0 : config.appName) || 'default-app');
        return _object_spread({}, defaultConfig, config);
    }, [
        config
    ]);
    var storageKeys = useMemo(function() {
        return resolveStorageKeys(finalConfig.storage);
    }, [
        finalConfig.storage
    ]);
    var tokenMgr = useMemo(function() {
        var _manager_configureStorage;
        var manager = injectedTokenManager || tokenManager;
        (_manager_configureStorage = manager.configureStorage) === null || _manager_configureStorage === void 0 ? void 0 : _manager_configureStorage.call(manager, finalConfig.storage);
        return manager;
    }, [
        injectedTokenManager,
        finalConfig.storage
    ]);
    var _useState = _sliced_to_array(useState({
        user: null,
        token: null,
        refreshToken: null,
        isAuthenticated: false,
        isLoading: true,
        error: null
    }), 2), authState = _useState[0], setAuthState = _useState[1];
    // 서비스 인스턴스 설정
    var ideMessengerInstance = ideMessagingService || null;
    var navigate = (navigationService === null || navigationService === void 0 ? void 0 : navigationService.navigate) || function() {};
    var isVSCodeEnv = isVSCodeEnvironment();
    // auth-client 사용 - services 대신 getCurrentUserApi 직접 사용
    var apiAxios = createAuthAxiosInstance({
        baseURL: typeof window !== 'undefined' && window.__API_BASE_URL__ || ((_env = import.meta.env) === null || _env === void 0 ? void 0 : _env.VITE_API_SERVER_URL) || process.env.API_SERVER_URL || 'https://api.ugot.uk',
        enableDebug: process.env.NODE_ENV === 'development',
        authServerUrl: finalConfig.api.authServerUrl,
        oauthClientId: finalConfig.oauth2.clientId
    });
    var apiService = {
        setToken: function(_token) {
            var _tokenType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Bearer';
        // 토큰은 tokenManager + interceptor에서 자동 적용됨
        },
        getAxiosInstance: function() {
            return apiAxios;
        }
    };
    console.log('[AuthProvider] 🔧 초기화 정보:', {
        isVSCodeEnv: isVSCodeEnv,
        hasTokenManager: !!tokenMgr,
        hasApiService: !!apiService,
        hasNavigationService: !!navigationService,
        url: typeof window !== 'undefined' ? window.location.href : 'server'
    });
    var lastTokenRef = useRef(null);
    // 안정적인 refs를 사용하여 무한 렌더링 방지
    var stableTokenMgr = useRef(tokenMgr);
    var stableApiService = useRef(apiService);
    var stableNavigate = useRef(navigate);
    var stableIdeMessenger = useRef(ideMessengerInstance);
    // refs 업데이트 (값이 실제로 변경될 때만)
    if (stableTokenMgr.current !== tokenMgr) stableTokenMgr.current = tokenMgr;
    if (stableApiService.current !== apiService) stableApiService.current = apiService;
    if (stableNavigate.current !== navigate) stableNavigate.current = navigate;
    if (stableIdeMessenger.current !== ideMessengerInstance) stableIdeMessenger.current = ideMessengerInstance;
    // 미디어 URL 정규화를 위한 기본 URL 계산
    var apiBaseFromEnv = useMemo(function() {
        var _process, _env, _this;
        var processBase = typeof process !== 'undefined' && ((_process = process) === null || _process === void 0 ? void 0 : _process.env) ? process.env.API_SERVER_URL : undefined;
        var candidates = [
            (_this = import.meta) === null || _this === void 0 ? void 0 : (_env = _this.env) === null || _env === void 0 ? void 0 : _env.VITE_API_SERVER_URL,
            processBase,
            'https://api.ugot.uk'
        ];
        var rawBase = candidates.find(function(value) {
            return typeof value === 'string' && value.trim().length > 0;
        }).trim();
        var normalizedBase = /^https?:\/\//i.test(rawBase) ? rawBase : "https://".concat(rawBase);
        return normalizedBase.replace(/\/$/, '');
    }, []);
    var ensureAbsoluteUrl = useCallback(function(url) {
        if (!url) return undefined;
        var trimmed = url.trim();
        if (!trimmed) return undefined;
        if (/^https?:\/\//i.test(trimmed)) return trimmed;
        var path = trimmed.startsWith('/') ? trimmed : "/".concat(trimmed);
        return "".concat(apiBaseFromEnv).concat(path);
    }, [
        apiBaseFromEnv
    ]);
    var normalizeUserMedia = useCallback(function(userData) {
        return _object_spread_props(_object_spread({}, userData), {
            avatar: ensureAbsoluteUrl(userData.avatar),
            profileImage: ensureAbsoluteUrl(userData.profileImage)
        });
    }, [
        ensureAbsoluteUrl
    ]);
    // 유틸리티 함수 생성을 위한 공통 설정 (안정적인 참조 사용)
    var utilsConfig = useMemo(function() {
        return {
            tokenManager: stableTokenMgr.current,
            apiService: stableApiService.current,
            isVSCodeEnv: isVSCodeEnv,
            ideMessengerInstance: stableIdeMessenger.current,
            navigate: stableNavigate.current,
            setAuthState: setAuthState,
            lastTokenRef: lastTokenRef,
            authConfig: finalConfig,
            storageKeys: storageKeys
        };
    }, [
        isVSCodeEnv,
        setAuthState,
        finalConfig,
        storageKeys
    ]);
    // 핵심 함수들 생성
    var handleLogout = useCallback(createLogoutHandler(utilsConfig), [
        utilsConfig
    ]);
    var fetchUserProfile = useCallback(createFetchUserProfile(utilsConfig), [
        utilsConfig
    ]);
    var startFreshAuth = useCallback(createStartFreshAuth(utilsConfig), [
        utilsConfig
    ]);
    var initializeAuth = useCallback(createAuthInitializer(_object_spread_props(_object_spread({}, utilsConfig), {
        fetchUserProfile: fetchUserProfile
    })), [
        utilsConfig,
        fetchUserProfile
    ]);
    // OAuth2 리다이렉트 핸들러를 위한 인증 상태 설정 함수 (먼저 정의)
    var setAuthenticatedState = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(user, accessToken, refreshToken, expiresIn) {
            var tokenType, idToken, _stack, authTokenManager, _authTokenManager_setExpiresIn, normalizedUser;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                tokenType = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : 'Bearer', idToken = _arguments.length > 5 ? _arguments[5] : void 0;
                console.log('[AuthProvider] 🔥 setAuthenticatedState 호출됨!', {
                    userId: user.id,
                    username: user.username,
                    accessToken: accessToken.substring(0, 20) + '...',
                    hasRefreshToken: !!refreshToken,
                    hasIdToken: !!idToken,
                    isVSCodeEnv: isVSCodeEnv,
                    timestamp: new Date().toISOString(),
                    stackTrace: (_stack = new Error().stack) === null || _stack === void 0 ? void 0 : _stack.split('\n').slice(1, 4).join('\n')
                });
                // 토큰 설정
                console.log('[AuthProvider] 💾 TokenManager.setToken 호출 중...', {
                    accessTokenLength: accessToken === null || accessToken === void 0 ? void 0 : accessToken.length
                });
                authTokenManager = stableTokenMgr.current;
                authTokenManager.setToken(accessToken, tokenType);
                if (typeof expiresIn === 'number' && expiresIn > 0) {
                    ;
                    (_authTokenManager_setExpiresIn = authTokenManager.setExpiresIn) === null || _authTokenManager_setExpiresIn === void 0 ? void 0 : _authTokenManager_setExpiresIn.call(authTokenManager, expiresIn);
                }
                console.log('[AuthProvider] 💾 ApiService.setToken 호출 중...', {
                    tokenType: tokenType
                });
                stableApiService.current.setToken(accessToken, tokenType);
                if (refreshToken) {
                    console.log('[AuthProvider] 💾 TokenManager.setRefreshToken 호출 중...', {
                        refreshTokenLength: refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.length
                    });
                    authTokenManager.setRefreshToken(refreshToken);
                }
                if (idToken) {
                    console.log('[AuthProvider] 💾 ID 토큰 저장:', idToken.substring(0, 20) + '...');
                    if (!isVSCodeEnv) {
                        localStorage.setItem(storageKeys.idTokenKey || ID_TOKEN_KEY, idToken);
                    }
                }
                // 인증 상태 업데이트
                console.log('[AuthProvider] 🔄 React state 업데이트 중...');
                normalizedUser = normalizeUserMedia(user);
                setAuthState(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        isAuthenticated: true,
                        user: normalizedUser,
                        token: accessToken,
                        refreshToken: refreshToken !== null && refreshToken !== void 0 ? refreshToken : prev.refreshToken,
                        idToken: idToken
                    });
                });
                // localStorage에 저장 (VS Code 환경이 아닌 경우에만)
                if (!isVSCodeEnv) {
                    console.log('[AuthProvider] 💾 localStorage 저장 시작...', {
                        userKeyConfig: storageKeys.userKey,
                        tokenKeyConfig: storageKeys.tokenKey,
                        refreshTokenKeyConfig: storageKeys.refreshTokenKey
                    });
                    localStorage.setItem(storageKeys.userKey, JSON.stringify(normalizedUser));
                    console.log('[AuthProvider] ✅ User 저장됨:', storageKeys.userKey);
                    localStorage.setItem(storageKeys.tokenKey, accessToken);
                    console.log('[AuthProvider] ✅ Access token 저장됨:', storageKeys.tokenKey);
                    if (refreshToken) {
                        localStorage.setItem(storageKeys.refreshTokenKey, refreshToken);
                        console.log('[AuthProvider] ✅ Refresh token 저장됨:', storageKeys.refreshTokenKey);
                    }
                } else {
                    console.log('[AuthProvider] ⚠️ VS Code 환경이므로 localStorage 저장 건너뜀');
                }
                console.log('[AuthProvider] ✅ 인증 상태 설정 완료');
                return [
                    2
                ];
            });
        });
        return function(user, accessToken, refreshToken, expiresIn) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isVSCodeEnv,
        setAuthState,
        normalizeUserMedia,
        storageKeys
    ]);
    var refreshAccessToken = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _authTokenManager_getTokenType, authTokenManager, refreshToken, result, nextRefreshToken, nextTokenType, _authTokenManager_setExpiresIn, _authTokenManager_clearToken;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (isVSCodeEnv) {
                        return [
                            2,
                            false
                        ];
                    }
                    authTokenManager = stableTokenMgr.current;
                    refreshToken = authTokenManager.getRefreshToken();
                    if (!refreshToken) {
                        console.warn('[AuthProvider] Refresh token not available.');
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        4,
                        handleRefreshTokenFlow(refreshToken, finalConfig.api.authServerUrl, ((_authTokenManager_getTokenType = authTokenManager.getTokenType) === null || _authTokenManager_getTokenType === void 0 ? void 0 : _authTokenManager_getTokenType.call(authTokenManager)) || 'Bearer', finalConfig.oauth2.clientId)
                    ];
                case 1:
                    result = _state.sent();
                    if (result.success && result.accessToken) {
                        nextRefreshToken = result.refreshToken || refreshToken;
                        nextTokenType = result.tokenType || 'Bearer';
                        authTokenManager.setRefreshToken(nextRefreshToken);
                        if (typeof result.expiresIn === 'number' && result.expiresIn > 0) {
                            ;
                            (_authTokenManager_setExpiresIn = authTokenManager.setExpiresIn) === null || _authTokenManager_setExpiresIn === void 0 ? void 0 : _authTokenManager_setExpiresIn.call(authTokenManager, result.expiresIn);
                        }
                        authTokenManager.setToken(result.accessToken, nextTokenType);
                        setAuthState(function(previous) {
                            return _object_spread_props(_object_spread({}, previous), {
                                token: result.accessToken || null,
                                refreshToken: nextRefreshToken,
                                isAuthenticated: Boolean(previous.user),
                                error: null
                            });
                        });
                        return [
                            2,
                            true
                        ];
                    }
                    if (result.error === 'invalid_grant') {
                        ;
                        (_authTokenManager_clearToken = authTokenManager.clearToken) === null || _authTokenManager_clearToken === void 0 ? void 0 : _authTokenManager_clearToken.call(authTokenManager);
                        setAuthState(function(previous) {
                            return _object_spread_props(_object_spread({}, previous), {
                                user: null,
                                token: null,
                                refreshToken: null,
                                isAuthenticated: false,
                                isLoading: false,
                                error: '인증 세션이 만료되었습니다.'
                            });
                        });
                    }
                    return [
                        2,
                        false
                    ];
            }
        });
    }), [
        finalConfig.api.authServerUrl,
        finalConfig.oauth2.clientId,
        isVSCodeEnv
    ]);
    var refreshAuth = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        refreshAccessToken()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        refreshAccessToken
    ]);
    // OAuth 핸들러들 생성 (setAuthenticatedState 포함)
    var exchangeGoogleToken = useCallback(createGoogleTokenExchange(_object_spread_props(_object_spread({}, utilsConfig), {
        fetchUserProfile: fetchUserProfile,
        setAuthenticatedState: isVSCodeEnv ? undefined : setAuthenticatedState
    })), [
        utilsConfig,
        fetchUserProfile,
        isVSCodeEnv,
        setAuthenticatedState
    ]);
    var exchangeGoogleAuthCode = useCallback(createGoogleAuthCodeExchange(_object_spread_props(_object_spread({}, utilsConfig), {
        fetchUserProfile: fetchUserProfile,
        setAuthenticatedState: isVSCodeEnv ? undefined : setAuthenticatedState
    })), [
        utilsConfig,
        fetchUserProfile,
        isVSCodeEnv,
        setAuthenticatedState
    ]);
    var exchangeKakaoAuthCode = useCallback(createKakaoAuthCodeExchange(_object_spread_props(_object_spread({}, utilsConfig), {
        fetchUserProfile: fetchUserProfile,
        setAuthenticatedState: isVSCodeEnv ? undefined : setAuthenticatedState
    })), [
        utilsConfig,
        fetchUserProfile,
        isVSCodeEnv,
        setAuthenticatedState
    ]);
    // 사용자 정보 업데이트 함수
    var updateUser = useCallback(function(userData) {
        setAuthState(function(prev) {
            if (!prev.user) {
                console.warn('[AuthProvider] 사용자가 로그인되지 않은 상태에서 업데이트 시도');
                return prev;
            }
            var updatedUser = normalizeUserMedia(_object_spread({}, prev.user, userData));
            if (!isVSCodeEnv) {
                localStorage.setItem(storageKeys.userKey, JSON.stringify(updatedUser));
            }
            return _object_spread_props(_object_spread({}, prev), {
                user: updatedUser
            });
        });
    }, [
        isVSCodeEnv,
        normalizeUserMedia,
        storageKeys.userKey
    ]);
    // 사용자 이메일 가져오기 함수
    var fetchUserEmail = useCallback(function() {
        return createFetchUserEmail(utilsConfig)(authState, updateUser);
    }, [
        utilsConfig,
        authState,
        updateUser
    ]);
    // 초기화 effect
    useEffect(function() {
        initializeAuth();
    }, [
        initializeAuth
    ]);
    // Keep consumers that read the React context in sync with interceptor-driven
    // token refreshes as well as the proactive refresh path above.
    useEffect(function() {
        var authTokenManager = stableTokenMgr.current;
        if (!authTokenManager.addTokenChangeListener || !authTokenManager.removeTokenChangeListener) {
            return;
        }
        var syncToken = function(token) {
            setAuthState(function(previous) {
                return token ? _object_spread_props(_object_spread({}, previous), {
                    token: token,
                    refreshToken: authTokenManager.getRefreshToken() || previous.refreshToken
                }) : _object_spread_props(_object_spread({}, previous), {
                    user: null,
                    token: null,
                    refreshToken: null,
                    isAuthenticated: false
                });
            });
        };
        authTokenManager.addTokenChangeListener(syncToken);
        return function() {
            var _authTokenManager_removeTokenChangeListener;
            return (_authTokenManager_removeTokenChangeListener = authTokenManager.removeTokenChangeListener) === null || _authTokenManager_removeTokenChangeListener === void 0 ? void 0 : _authTokenManager_removeTokenChangeListener.call(authTokenManager, syncToken);
        };
    }, []);
    useEffect(function() {
        if (isVSCodeEnv || !authState.isAuthenticated) {
            return;
        }
        var authTokenManager = stableTokenMgr.current;
        if (!authTokenManager.getRefreshToken()) {
            return;
        }
        var expiresAt = localStorage.getItem(storageKeys.tokenExpiresAtKey);
        var delay = resolveAccessTokenRefreshDelay(expiresAt);
        if (delay === null) {
            return;
        }
        var cancelled = false;
        var retryTimer = null;
        var runRefresh = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var refreshed;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                refreshAccessToken()
                            ];
                        case 1:
                            refreshed = _state.sent();
                            if (!refreshed && !cancelled && authTokenManager.getRefreshToken()) {
                                retryTimer = setTimeout(runRefresh, 30000);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function runRefresh() {
                return _ref.apply(this, arguments);
            };
        }();
        var refreshTimer = setTimeout(runRefresh, delay);
        return function() {
            cancelled = true;
            clearTimeout(refreshTimer);
            if (retryTimer) {
                clearTimeout(retryTimer);
            }
        };
    }, [
        authState.isAuthenticated,
        authState.token,
        isVSCodeEnv,
        refreshAccessToken,
        storageKeys.tokenExpiresAtKey
    ]);
    // 컨텍스트 값을 생성하고 getter 속성 추가
    var contextValue = useMemo(function() {
        var value = {
            state: authState,
            login: /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(credentials) {
                    return _ts_generator(this, function(_state) {
                        console.warn('Credential-based login not implemented');
                        return [
                            2
                        ];
                    });
                });
                return function(credentials) {
                    return _ref.apply(this, arguments);
                };
            }(),
            register: /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(data) {
                    return _ts_generator(this, function(_state) {
                        console.warn('Registration not implemented');
                        return [
                            2
                        ];
                    });
                });
                return function(data) {
                    return _ref.apply(this, arguments);
                };
            }(),
            logout: handleLogout,
            refreshAuth: refreshAuth,
            clearError: function() {
                return setAuthState(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        error: null
                    });
                });
            },
            hasRole: function(role) {
                var _authState_user;
                return ((_authState_user = authState.user) === null || _authState_user === void 0 ? void 0 : _authState_user.role) === role;
            },
            fetchUserEmail: fetchUserEmail,
            startFreshAuth: isVSCodeEnv ? undefined : startFreshAuth,
            setAuthenticatedState: isVSCodeEnv ? undefined : setAuthenticatedState,
            exchangeGoogleToken: isVSCodeEnv ? undefined : exchangeGoogleToken,
            exchangeGoogleAuthCode: isVSCodeEnv ? undefined : exchangeGoogleAuthCode,
            exchangeKakaoAuthCode: isVSCodeEnv ? undefined : exchangeKakaoAuthCode,
            // 하위 호환성을 위한 속성들
            user: authState.user,
            token: authState.token,
            isLoading: authState.isLoading,
            isInitialized: authState.isInitialized
        };
        // isAuthenticated를 getter로 정의
        Object.defineProperty(value, 'isAuthenticated', {
            get: function get() {
                return authState.isAuthenticated;
            },
            enumerable: true,
            configurable: true
        });
        return value;
    }, [
        authState,
        handleLogout,
        refreshAuth,
        fetchUserEmail,
        isVSCodeEnv,
        startFreshAuth,
        setAuthenticatedState,
        exchangeGoogleToken,
        exchangeGoogleAuthCode,
        exchangeKakaoAuthCode
    ]);
    console.log('[AuthProvider] 🎯 Context Value:', {
        hasSetAuthenticatedState: !!contextValue.setAuthenticatedState,
        setAuthenticatedStateName: (_contextValue_setAuthenticatedState = contextValue.setAuthenticatedState) === null || _contextValue_setAuthenticatedState === void 0 ? void 0 : _contextValue_setAuthenticatedState.name,
        setAuthenticatedStateString: ((_contextValue_setAuthenticatedState1 = contextValue.setAuthenticatedState) === null || _contextValue_setAuthenticatedState1 === void 0 ? void 0 : _contextValue_setAuthenticatedState1.toString().substring(0, 100)) + '...',
        isVSCodeEnv: isVSCodeEnv,
        authState: {
            isAuthenticated: authState.isAuthenticated,
            isLoading: authState.isLoading,
            hasUser: !!authState.user,
            hasToken: !!authState.token
        }
    });
    return contextValue;
};
